/**
 * 抽奖奖励配置
 * 每个奖励包含：名称、概率、后端配置ID、图标路径
 */
export const rewardList = [
  {
    name: "愛心領寵牌*2",
    probability: "2%",
    configId: "22691c24",
    icon: "1.png",
  },
  {
    name: "老舊卡冊*2",
    probability: "3%",
    configId: "fb2ae520",
    icon: "2.png",
  },
  {
    name: "元素結晶寶箱*1",
    probability: "4%",
    configId: "9e8ac799",
    icon: "3.png",
  },
  {
    name: "金幣*888",
    probability: "6%",
    configId: "c872abae",
    icon: "4.png",
  },
  {
    name: "精煉自選禮盒*1",
    probability: "10%",
    configId: "d15458e4",
    icon: "5.png",
  },
  {
    name: "血跡樹枝*1",
    probability: "12%",
    configId: "ee58352f",
    icon: "6.png",
  },
  {
    name: "馬牌*1",
    probability: "16%",
    configId: "f26316aa",
    icon: "7.png",
  },
  {
    name: "寵物飼料*5",
    probability: "22%",
    configId: "ac469a65",
    icon: "8.png",
  },
  {
    name: "冒險幣*10000",
    probability: "25%",
    configId: "4d073ce7",
    icon: "9.png",
  },
];

/**
 * 根据后端配置ID获取奖励信息
 * @param {string} configId 后端配置ID
 * @returns {object|null} 奖励信息对象，未找到返回null
 */
export const getRewardByConfigId = (configId) => {
  return rewardList.find((reward) => reward.configId === configId) || null;
};

/**
 * 根据后端配置ID获取奖励名称
 * @param {string} configId 后端配置ID
 * @returns {string} 奖励名称，未找到返回默认值
 */
export const getRewardNameByConfigId = (configId) => {
  const reward = getRewardByConfigId(configId);
  return reward ? reward.name : "未知獎勵";
};

/**
 * 根据后端配置ID获取奖励图标路径
 * @param {string} configId 后端配置ID
 * @returns {string} 图标路径
 */
export const getRewardIconByConfigId = (configId) => {
  const reward = getRewardByConfigId(configId);
  if (reward) {
    return new URL(`../assets/images/award/${reward.icon}`, import.meta.url).href;
  }
  return "";
};
